<template>
  <SideNav />
  <header>
    <div
      class="page-header min-vh-50 "
      style="background-image: url('assets/img/child2.jpg');"
    >
      <span class="mask bg-black opacity-5" />
    </div>
    <div class="position-relative">
      <div class="container px-md-0 position-relative"> 
        <div class="bg-gradient-primary py-4 z-index-2 border-radius-xl mt-n7 mt-sm-n9 mt-md-n10  position-relative">        
          <div class="row align-items-center">
            <img
              src="assets/img/shapes/pattern-lines.svg"
              alt="pattern-lines"
              class="position-absolute opacity-6 start-0 top-0 linebg"
              style="z-index: 10;"
            >         
            <div
              class="px-3 ps-md-5 px-lg-5 col-12 col-md-5 col-lg-5  order-2 order-md-1"
              style="z-index: 20;"
            > 
              <div class="text-center text-md-start py-3 py-sm-5 ">
                <div class="position-relative">
                  <h3 class="text-white mt-sm-0 mb-3">
                    Tron Edu<br class="d-none d-md-block d-lg-none"> 創益學
                  </h3>
                  <p class="text-white mb-3">
                    TronEdu Curriculum Platform<br>
                    TronEdu Exam Platform<br>
                    <a
                      class="page-link"
                      href="javascript:;"
                      @click="goToPage('TronEduExamEditor')"
                    >
                      TronEdu Exam Editor
                      <br>
                    </a>
                  </p>
                  <!--
                    @click="goToPage('TronEduItem')"
                    @click="goToPage('ProductSeriesItem',{sid:1,pid:1})"
                  -->
                  <a
                    href="javascript:;"
                    type="button"
                    class="btn bg-gradient-dark btn-lg me-3 mt-3"
                  ><i class="material-icons me-2">menu_book</i>技術支援</a>                      
                </div>
              </div>
            </div>
            <div
              class="col-12 col-md-7 col-lg-7 order-1 order-md-2 mt-n7 mt-md-0 mt-lg-n7 move-on-hover"
              style="z-index: 10;"
            >
              <img
                class="w-100"
                src="assets/img/macbook-2.png"
                alt="macbook"
                loading="lazy"
              >
            </div>    
          </div>
        </div> 
      </div>
    </div>
  </header>

  
  <div class="py-5 pt-lg-5 pb-lg-6 container px-0">
    <div class="p-0 info-hoverprimary text-center mb-4 mt-md-6">
      <div class="icon icon-shape bg-gradient-primary shadow icon-shape-circle text-primary">
        <i
          class="fa fa-objects-column opacity-10"
          aria-hidden="true"
        />
      </div>
    </div>
    <h4 class="mb-4 text-center mb-6">
      Design Concept 設計理念
    </h4>
    <div class="row align-items-center mx-0 mb-5">
      <div class="p-5 col-xl-6">
        <img
          src="assets/img/tronedu2.jpg"
          class="img-fluid rounded shadow-lg move-on-hover"
        >
      </div>            
      <div class="p-5 col-xl-6 mt-lg-0 ps-lg-0 ps-0">
        <p class="mb-0 mt-5 mt-xl-0">
          <ul class="mb-0">
            <li class="mb-3">
              解決各教育機構在導入雲端教育科技應用需要投入高額人力成本的問題，降低導入失敗的風險。
            </li>
            <li class="mb-3">
              低廉的成本帶動人人負擔的起的雲端教育應用服務積極回饋偏鄉學校、弱勢家庭等族群。
            </li>
            <li>
              研發高科技的人工智能與雲端應用，輔助教職人員提高教學品質及減輕工作重擔。
            </li>
          </ul>
        </p>
      </div>
    </div>
    <div class="p-3 info-hoverprimary text-center mb-4 mt-md-6">
      <div class="icon icon-shape bg-gradient-primary shadow icon-shape-circle text-primary">
        <i
          class="fa fa-cube  opacity-10"
          aria-hidden="true"
        />
      </div>
    </div>
    <h4 class="mb-4 text-center mb-6">
      Tron Edu 創益學產品介紹
    </h4>
    <div class="row align-items-center mx-0">
      <div class="d-lg-none">
        <div class="border border-primary text-primary p-3 rounded mb-4">
          <p class="mb-0">
            創益學 TronEdu v2.0 教育大平台，是一套整合多種教育科技相關應用平台的解決方案，
            目的在於提供教育機構打造功能強大、容易導入、節省成本的雲端服務平台，讓學生、家長、老師都可以輕鬆無負擔的體驗教育科技替生活帶來的便利。
          </p>
        </div>
      </div>
      <div class="mx-auto col-md-6 col-lg-6 order-2 order-md-1">
        <div class="border border-primary text-primary p-3 rounded mb-4 d-none d-lg-block">
          <p class="mb-0">
            創益學 TronEdu v2.0 教育大平台，是一套整合多種教育科技相關應用平台的解決方案，
            目的在於提供教育機構打造功能強大、容易導入、節省成本的雲端服務平台，讓學生、家長、老師都可以輕鬆無負擔的體驗教育科技替生活帶來的便利。
          </p>
        </div>
        <p class="text-dark lh-lg">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          創益學 TronEdu 主平台課程平台系統（Curriculum Platform）為支援小學、國中、高中五個學習階段、108課綱、全領域、全科、全版及知識架構的課程管理平台，
          系統可透過昀揚科技的雲端資料中心更新教育部公佈每年最新版的知識架構與課綱，亦可應用在專業證照、教育訓練、高普考、幼兒等需求且可客製化知識架構及課綱。
          使用者可選購各種平台系統方案，部署在線上考試、出卷、線上影音函授課程、電子書、學力診斷、學習診斷、智能補救、智能助理、遠距教學等雲端應用。
        </p>
      </div>
      <div class="col-10 col-md-6 col-lg-5 order-1 order-md-2 mb-5 mb-md-0 ms-auto mx-auto move-on-hover">
        <img
          src="assets/img/edu4.jpg"
          class="img-fluid rounded shadow-lg"
        >
      </div>
    </div>
    <section class="pt-5 pt-lg-4">
      <div class="container px-0">
        <div class="p-3 info-hoverprimary text-center mb-4 mt-6">
          <div class="icon icon-shape bg-gradient-primary shadow icon-shape-circle text-primary">
            <i
              class="fa fa-network-wired  opacity-10"
              aria-hidden="true"
            />
          </div>
        </div>
        <h4 class="mb-4 text-center mb-6">
          Tron Edu 創益學系統規格
        </h4>
        <div class="row align-items-center mx-0 mb-5">
          <div class="col-xl-6 mb-5">
            <img
              src="assets/img/edu5.jpg"
              class="img-fluid rounded shadow-lg move-on-hover"
            >
          </div>            
          <div class="col-xl-6 mt-lg-0 mt-5 ps-lg-0 ps-0">
            <div class="p-3 info-horizontal">
              <div class="d-flex align-items-center mb-2"> 
                <div> 
                  <div class="icon icon-shape  bg-gradient-primary text-center rounded-pill shadow-none">
                    <i
                      class="fas fa-spell-check opacity-10 text-lg"
                      aria-hidden="true"
                    />
                  </div>
                </div>
                <div class="ms-3"> 
                  <h5 class="mb-0 ">
                    創益學平台
                  </h5>
                  <span class="text-normal  text-info">Curriculum Platform</span>
                </div>
              </div>
              <div class="description ps-5">
                <ul class="mb-0">
                  <li class="mb-3">
                    獨家<b>「智能雲端課程編排系統」</b>專利技術，解決各校不同課程版本造成課程內容無法統一的問題，本產品可有效為業者解決管理數位教材內容及剪輯維護影片的巨額成本與時間難題。
                  </li>
                  <li>嚴格參照教育部公佈之108課綱、領域架構規範，採集的Token對於AI的訓練可以有更加傑出的表現，更可讓大語言模型（LLM）訓練出更人性化且聰明的<b>「人工智能助教」</b>、<b>「人工智能家教」</b>模型。</li>
                </ul>
              </div>
            </div>              
            <div class="p-3 info-horizontal">
              <div class="d-flex align-items-center mb-2"> 
                <div> 
                  <div class="icon icon-shape  bg-gradient-primary text-center rounded-pill shadow-none">
                    <i
                      class="fas fa-photo-film-music opacity-10 text-lg"
                      aria-hidden="true"
                    />
                  </div>
                </div>
                <div class="ms-3">
                  <h5 class="mb-0">
                    CRStream 多媒體串流平台
                  </h5>                
                  <span class="text-normal  text-info">CRStream Platform</span>
                </div>
              </div>
              <div class="description ps-5">
                <ul class="mb-0">
                  <li class="mb-3">
                    <b>Streaming Media Distribution Network（SMDN）</b>獨家專利技術，比起傳統架構與各種現行通用架構有更加優化的穩定性及良率，大幅度節省網路成本。
                  </li>
                  <li>成熟且安全的影片 DRM 加密技術，提供各種解析度、浮水印等保護機制。</li>
                </ul>
              </div>
            </div>
          </div>        
        </div>
        <div class="row align-items-center mx-0 mb-5">
          <div class="col-lg-8  order-2 order-lg-1">
            <div class="p-3 info-horizontal">
              <div class="d-flex align-items-center mb-2"> 
                <div>
                  <div class="icon icon-shape  bg-gradient-primary text-center rounded-pill shadow-none">
                    <i
                      class="fas fa-laptop-file opacity-10 text-lg"
                      aria-hidden="true"
                    />
                  </div>
                </div>
                <div class="ms-3">
                  <h5 class="mb-0">
                    創益題平台
                  </h5>                
                  <span class="text-normal  text-info">Exam Platform</span>
                </div>
              </div>
              <div class="description ps-5">
                <ul class="mb-0">
                  <li class="mb-3">
                    獨家<b>「跨載具命題系統」</b>專利技術，
                    憑藉多年來各家教育集團、教育機構、地方政府、學校編輯人員、各領域教師的編輯操作使用經驗，解決現行小學、國中、高中的全科、全版編輯及全載具解析度問題。
                    採用 Microsoft Word 做為主要的編輯工具，並可同步題庫內容到雲端，大幅度的降低雲端題庫各種應用整合風險及成本，是一套成熟且具備豐富技術know-how的穩定產品。
                  </li>
                  <li>
                    Cloud Raise累積數年豐富的 K12
                    教育科技整合經驗，設計出最符合出題和編輯人員使用習慣的編輯管理工具及雲端資料中心服務系統，採用標準化的RESTful API風格架構和容器化微服務架構，支援全載具（手機、 平板、 電腦、
                    智慧電視）等環境，讓使用者可以運用本系統快速的建置、擴展高效穩定的題庫應用相關平台和服務。
                  </li>
                </ul>
              </div>
            </div>             
          </div>     
          <div class="mx-auto col-md-8 col-lg-4 order-1 order-lg-2 move-on-hover">
            <img
              src="assets/img/ASD.png"
              class="img-fluid "
            >
          </div> 
        </div>
        <div class="row align-items-center mx-0">
          <div class="mx-auto col-md-8 col-lg-5 mb-4 mb-lg-0 pe-lg-4 move-on-hover">
            <img
              src="assets/img/test1-1.png"
              class="img-fluid "
            >
          </div>      
          <div class="col-lg-7">
            <div class="p-3 info-horizontal">
              <div class="d-flex align-items-center mb-2"> 
                <div>
                  <div class="icon icon-shape  bg-gradient-primary text-center rounded-pill shadow-none">
                    <i
                      class="fas fa-cloud-question opacity-10 text-lg"
                      aria-hidden="true"
                    />
                  </div>
                </div>
                <div class="ms-3">
                  <h5 class="mb-0">
                    昀揚科技技術支援平台
                  </h5>                
                  <span class="text-normal  text-info">Cloud Raise Support Platform</span>
                </div>  
              </div>
              <div class="description ps-5">
                <ul class="mb-0">
                  <li class="mb-3">
                    系統提供升級、下載、授權、更新、CRM 等服務，支援最新小國高課程知識架構更新服務。
                  </li>
                </ul>
              </div>
            </div>   
            <div class="p-3 info-horizontal">
              <div class="d-flex align-items-center mb-2"> 
                <div>
                  <div class="icon icon-shape  bg-gradient-primary text-center rounded-pill shadow-none">
                    <i
                      class="fas fa-box-taped opacity-10 text-lg"
                      aria-hidden="true"
                    />
                  </div>
                </div>
                <div class="ms-3">
                  <h5 class="mb-0">
                    容器化微服務架構
                  </h5>                
                  <span class="text-normal  text-info">Containerizations , Microservices Architecture</span>
                </div>  
              </div>
              <div class="description ps-5">
                <ul class="mb-0">
                  <li class="mb-3">
                    全面採用容器化微服務架構有著高度的可靠性（Reliability）、可用性（Availability）、可維護性（Serviceability），大幅度的節省部署與維運成本。
                  </li>
                </ul>
              </div>
            </div>             
            <div class="p-3 info-horizontal">
              <div class="d-flex align-items-center mb-2"> 
                <div>
                  <div class="icon icon-shape  bg-gradient-primary text-center rounded-pill shadow-none">
                    <i
                      class="fas fa-gear-complex-code opacity-10 text-lg"
                      aria-hidden="true"
                    />
                  </div>
                </div>
                <div class="ms-3">
                  <h5 class="mb-0">
                    整合元件
                  </h5>                
                  <span class="text-normal  text-info">Integrated Components</span>
                </div>  
              </div>
              <div class="description ps-5">
                <ul class="mb-0">
                  <li class="mb-3">
                    全面採用 RESTful API 風格架構，支援 Postman API，提供跨載具SDK（利用本產品您可以輕鬆整合您的服務在各種載具上），功能架構的一致性提供了系統高度的擴展性和可重覆利用性，大幅度節省開發與整合成本。
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <img
          src="assets/img/syudy1.jpg"
          class="img-fluid my-4"
        >
      </div>
    </section>
    <!--
      <div class="p-3 info-hover-warning text-center mb-4 mt-8">
        <div class="icon icon-shape bg-gradient-primary shadow icon-shape-circle text-primary">
          <i class="fa fa-pen  opacity-10"></i>
        </div>
      </div>
      <h4 class="mb-4 text-center mb-6">創益題產品DM</h4>    
        <div class="row">
        <div class="col-lg-6">
                <img class="img-fluid rounded shadow-lg" src="assets/img/tronedudm1.jpg">
        </div>
        <div class="col-lg-6 mt-5 mt-lg-0">
        <img class="img-fluid rounded shadow-lg" src="assets/img/tronedudm2.jpg">
    </div>
    </div>
-->
  </div>  

  <footer class="footer mt-5">
    <div class="container">
      <div class=" row align-items-center">
        <div class="col-md-6 mb-md-4 me-auto">
          <div class="d-none d-md-block">
            <a 
              href="javascript:;"
              @click="goToPage('/')"
            >
              <img
                src="assets/img/logo4.svg"
                class="mb-3"
                style="width: 160px;"
              >
            </a>
          </div>
        </div>

        <div class="col-md-6 mb-md-4 ms-auto text-center text-md-end">
          <a class="mb-3"><img
            src="assets/img/logo4.svg"
            style="width: 160px;"
            class="mb-3 d-md-none"
          ></a>

          <p class="mb-1">
            service@cloudraise.com
          </p>
          <p class="mb-1">
            新北市三重區重新路五段609巷14號5樓之3
          </p>
          <p class="mb-1">
            02-29992891
          </p>
        </div>
        <div class="col-12">
          <div class="text-center">
            <p class="text-dark my-2 my-md-4 text-sm font-weight-normal">
              Copyright ©
              2023
              by Cloud Raise Technology.
            </p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
/* eslint-disable import/no-absolute-path */
// eslint-disable-next-line import/no-unresolved
import { config } from '@/include/config';
import {
  h,
  ref,
  toRefs,
  reactive,
  watch,
  inject,
  onMounted,
  onBeforeUpdate,
  onUpdated
} from 'vue';
import { oltConsole, oAA , oAuth, oApiError , oFrame } from '@/lib/oltModule/initOltVue3';
import { SideNav , Header , ProductHeader , Footer } from '@/components/Frame';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';

export default {
  name: 'App',
  components: {
    SideNav,
    //Header,
    //ProductHeader,
    //NavBar,
    // Settings,
    //Footer,
  },
  setup() {

    /**
     *  swal start
     */
    const swal = inject('$swal');
    /**
     *  swal end
     */

    const router = useRouter();
    const route = useRoute();
    const store = useStore();

    const nid = ref();

    //console.log('router.currentRoute.value : ', router.currentRoute.value.query);
    /*
    if(router.currentRoute.value.query.nid == null || router.currentRoute.value.query.nid == '' ){
      swal.fire({
        icon:'error',
        html:'路徑錯誤！！',
        buttonsStyling: true,
        confirmButtonClass: 'md-button md-success',
        //confirmButtonText:t('messages.confirm_button'),
      }).then( result => {
        if (result.value) {
          //console.log('result : ' , result);
          //emit('addCallBack');
          //router.go(-1);
          goToPage('/');
        }
      });
    }
	*/
    nid.value= router.currentRoute.value.query.nid ; 

    //console.log('nid' , nid.value);

    onMounted(async () => {
      chkLogin();
    });
    // Reload MDInput End

    onUpdated(async () => {
      // 修改 VUE 時 必需全部強制關閉 Modals 
      // eslint-disable-next-line no-undef
      //await oAdminFrame.closeAllModals() ;
    }) ;

    function goToPage(pageItem,queryItem){
      if(router.currentRoute.value.name == pageItem) { return; }
      //router.push(page);
      //router.push({ path:'Home' , query:{page:1,blid:1}} );
      //console.log('pageItem : ', pageItem);
      router.push({ path:pageItem , query:queryItem} );
    }




    function chkLogin(){
      let isLogin = oAuth.isLogin(store);

      if(!isLogin){
        //router.push({ path: '/AuthPage/SignIn' });
      }
    }

    return {
      hiddenHeader:false,
      // api setting
      setDebugMode: true,
      apiDebug: false,
      apiName: '',
      perPage: 3, //筆數
      pageMode: true,
      perPageOptions: [5, 10, 25, 50, 75, 100],
      // data
      userInfo:{coin:0 , point:0},
      token:null,
      nid,
      // function
      goToPage,
      chkLogin,
    };
  },
  created() {
  },
  mounted() {
    oFrame.initMD();
  },
  methods: {
  }
};
</script>
